import type { IconType } from 'react-icons';
import { TbCopyPlus, TbShieldCheck, TbSquareCheckFilled } from 'react-icons/tb';

export type RoleBuilderSection = 'details' | 'policies' | 'templates';

export interface RoleBuilderStep {
    icon: IconType;
    key: RoleBuilderSection;
    label: string;
}

export const roleBuilderSteps: RoleBuilderStep[] = [
    { icon: TbShieldCheck, key: 'details', label: 'Role Details' },
    { icon: TbSquareCheckFilled, key: 'policies', label: 'Custom Policies' },
    { icon: TbCopyPlus, key: 'templates', label: 'Templates' },
];
